module.exports = __webpack_public_path__ + "img/questionTech.dc505813.svg";